<template>
    <div class="notice-container">
        <div v-if="props.data && props.data.length > 0" class="notice-content flex-start">
            <div class="left-wrap pointer" @click="goDetail(activeInfo)">
                <LazyImage :src="activeInfo.coverUrl || defaultNewsImg" class-name="notice-img" />
                <div class="header-bg">
                    <p class="header overflow-ellipsis" :title="activeInfo.contentTitle">
                        <span>{{ activeInfo.contentTitle }}</span>
                    </p>
                </div>
            </div>
            <ul class="right-wrap" v-if="realList.length > 1">
                <li
                    v-for="item in realList"
                    :key="item.contentId"
                    :class="[
                        'notice-item',
                        'flex-start',
                        'pointer',
                        { active: item.contentId === activeInfo.contentId },
                    ]"
                    @click="goDetail(item)"
                    @mouseenter="onHover(item)"
                >
                    <p class="notice-text overflow-ellipsis">
                        <span class="notice-tag" v-if="item.tag">{{ item.tag }}</span>
                        <span :title="item.contentTitle" v-link="getDetailLink(item)">{{
                            item.contentTitle
                        }}</span>
                    </p>
                    <p class="light-gray-font-color">{{ item.publishTime }}</p>
                </li>
            </ul>
        </div>
        <BigNoData class="mar-top49" v-else url="no-news@2x.png" info="暂无公告，静候通知" />
    </div>
</template>

<script setup>
import BigNoData from '@/components/no-data.vue';
import LazyImage from '@/components/lazy-image/lazy-image.vue';
import { computed, ref, watch } from 'vue';
import { goNewsDetail, getLink } from '@/lib/tools.js';

// const defaultNewsImg = 'https://srt-read-online.3ren.cn/basebusiness/material/20221102/16673627738023vUnoocsyi002.jpg'
const defaultNewsImg =
    'https://srt-read-online.3ren.cn/basebusiness/material/20221109/1667962142168iPiQ3Kb84g001.jpg';

const props = defineProps({
    data: {
        // 通知公告列表
        type: Array,
        default: () => [],
    },
});

// 是否显示更多公告新闻
const realList = computed(() => {
    return (props.data?.length && props.data.slice(0, 6)) || [];
});

// 当前激活的公告item
const activeInfo = ref({});

// 跳转公告详情页
function goDetail(info) {
    goNewsDetail(info, 'noticeDetail');
}

function getDetailLink(info) {
    return getLink(info, 'noticeDetail');
}

function onHover(info) {
    activeInfo.value = info;
}

watch(
    () => props.data,
    val => {
        if (val && val.length) {
            activeInfo.value = val[0];
        }
    },
    {
        deep: true,
        immediate: true,
    },
);
</script>

<style lang="scss" scoped>
.notice-container {
    margin-top: 26px;
    .notice-content {
        .left-wrap {
            position: relative;
            width: 373px;
            height: 210px;
            background: #f7f9fa;
            .notice-img {
                width: 373px;
                height: 210px;
                border-radius: 4px;
            }
            .header-bg {
                position: absolute;
                bottom: 0;
                width: 100%;
                height: 70px;
                background: linear-gradient(360deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%);
                border-radius: 0px 0px 4px 4px;
                .header {
                    font-size: 16px;
                    color: #ffffff;
                    font-weight: bold;
                    line-height: 24px;
                    margin-top: 26px;
                    padding-left: 20px;
                    padding-right: 20px;
                    position: relative;
                    // display: flex;
                    &:hover {
                        color: var(--home-main-color);
                    }
                }
            }
        }
        .right-wrap {
            flex: 1;
            height: 210px;
            display: block;
            overflow: hidden;
            .notice-item {
                font-size: 14px;
                color: var(--srt-color-black);
                box-sizing: border-box;
                margin: 5px 0 0 20px;
                .notice-tag {
                    font-size: 12px;
                    color: var(--home-main-color);
                    background: var(--home-color-bg);
                    padding: 0 4px;
                    line-height: 18px;
                    border-radius: 3px;
                    vertical-align: text-bottom;
                    // margin-right: 12px;
                }
                &.active {
                    p {
                        color: var(--home-main-color);
                    }
                }
                .notice-text {
                    width: 100%;
                    margin-right: 24px;
                }

                &:nth-child(n + 2) {
                    margin: 16px 0 0 20px;
                }
            }
        }
    }
    .mar-top49 {
        margin-top: 49px;
    }
}
</style>
